module.exports = "https://vote4-campaigns-cdn.fire-emblem-heroes.com/images/src/assets/images/series/pt-BR/img_series-107.png";